import Vue from 'vue';
import Acl from 'vue-browser-acl';
import store from '../store';
import router from '../router';

Vue.use(
    Acl,
    () => {
        return store.getters['auth/user'];
    },
    (acl) => {
        // Global rules
        acl.rule('is-logged-in', () => {
            return store.getters['auth/isLoggedIn'];
        });

        acl.rule('admin', (user) => {
            return user.admin;
        });

        acl.rule('supplier', (user) => {
            if(user.admin) {
                return true;
            }

            if(!Object.prototype.hasOwnProperty.call(user, '_roles')) {
                return false;
            }

            return user._roles.indexOf('ROLE_SUPPLIER') > -1;
        });

        acl.rule('operator', (user) => {
            if(user.admin) {
                return true;
            }

            if(!Object.prototype.hasOwnProperty.call(user, '_roles')) {
                return false;
            }

            return user._roles.indexOf('ROLE_PARTNER') > -1;
        });

        acl.rule('view-profile', (user) => {
            if(!Object.prototype.hasOwnProperty.call(user, '_roles')) {
                return false;
            }

            return user._roles.indexOf('ROLE_PARTNER') > -1;
        });

        acl.rule('view-tourbook', (user) => {
            if(user.admin) {
                return true;
            }
            if(!Object.prototype.hasOwnProperty.call(user, '_roles')) {
                return false;
            }

            return user._roles.indexOf('_ROLE_TOURBOOK') > -1;
        });
    },
    {
        router,
    }
);
